var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"Thankyou3"}},[_c('div',{staticClass:"section"},[_c('div',{staticClass:"library-info"},[_c('h2',{staticClass:"section-title",attrs:{"id":"up"}},[_vm._v("GRAZIE !")]),_c('h3',{staticStyle:{"font-size":"2em","text-align":"center"}},[_vm._v("Tra pochi secondi sarai reindirizzato per scaricare il nostro ebook!")])])])])
}]

export { render, staticRenderFns }